var a="\n";export{a as default};
